<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <li class="active">CSVエクスポート</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>CSVエクスポート</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div class="tab-content">
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="radio inline-box">
                    <label>
                      <input name="form-field-radio" type="radio" class="ace" value="user" v-model="exportTable">
                      <span class="lbl">ユーザー</span>
                    </label>
                  </div>
                  <div class="radio inline-box">
                    <label>
                      <input name="form-field-radio" type="radio" class="ace" value="pcode" v-model="exportTable">
                      <span class="lbl">個人コード</span>
                    </label>
                  </div>
                  <div class="radio inline-box">
                    <label>
                      <input name="form-field-radio" type="radio" class="ace" value="phone" v-model="exportTable">
                      <span class="lbl">スマートフォン</span>
                    </label>
                  </div>
                  <div class="radio inline-box">
                    <label>
                      <input name="form-field-radio" type="radio" class="ace" value="gate" v-model="exportTable">
                      <span class="lbl">ゲート</span>
                    </label>
                  </div>
                  <div class="radio inline-box">
                    <label>
                      <input name="form-field-radio" type="radio" class="ace"  value="group" v-model="exportTable">
                      <span class="lbl">ゲートグループ</span>
                    </label>
                  </div>
                  <div class="radio inline-box">
                    <label>
                      <input name="form-field-radio" type="radio" class="ace"  value="groupuser" v-model="exportTable">
                      <span class="lbl">ゲートグループに所属するユーザー</span>
                    </label>
                  </div>
                  <div class="radio inline-box">
                    <label>
                      <input name="form-field-radio" type="radio" class="ace"  value="groupgate" v-model="exportTable">
                      <span class="lbl">ゲートグループに所属するゲート</span>
                    </label>
                  </div>
                  <!--<div class="radio inline-box">
                    <label>
                      <input name="form-field-radio" type="radio" class="ace"  value="logs" v-model="exportTable">
                      <span class="lbl">照合ログ</span>
                    </label>
                  </div>
                  <div class="radio inline-box">
                    <label>
                      <input name="form-field-radio" type="radio" class="ace"  value="ownlogs" v-model="exportTable">
                      <span class="lbl">操作ログ</span>
                    </label>
                  </div>-->
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="alert alert-danger" v-if="message !== ''">
                    {{ message }}
                  </div>
                  <a class="btn btn-info save_group_bottom" :disabled="isVisible" v-if="isVisible">エクスポート</a>
                  <a class="btn btn-info save_group_bottom" :disabled="isVisible" href="#process" data-toggle="modal" @click="exportDataExe()" v-else>エクスポート</a>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <!-- プロフィールModal -->
    <div id="process" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <span class="progress-question">エクスポート進捗状況</span>
            <div class="progress" v-bind:class="{'progress-striped':animation , active:animation}">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success" @click="resetProcess()">OK</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'
import saveAs from 'file-saver/dist/FileSaver'

export default {
  data () {
    return {
      progress: 0,
      success: false,
      percentUser: 0,
      percentPcode: 0,
      percentPhone: 0,
      percentGate: 0,
      percentGroup: 0,
      percentGroupUser: 0,
      percentGroupGate: 0,
      groupInfor: {
        name: '',
        isValid: true
      },
      exportData: [],
      headerData: [],
      userData: null,
      pcodeData: null,
      phoneData: null,
      gateData: null,
      groupData: null,
      groupUserData: null,
      groupGateData: null,
      logsData: null,
      ownLogsData: null,
      pagesUser: 0,
      userDataLoad: 0,
      pagesPcode: 0,
      pcodeDataLoad: 0,
      pagesPhone: 0,
      phoneDataLoad: 0,
      pagesGate: 0,
      gateDataLoad: 0,
      pagesGroup: 0,
      groupDataLoad: 0,
      pagesGroupUser: 0,
      groupUserDataLoad: 0,
      pagesGroupGate: 0,
      groupGateDataLoad: 0,
      pagesLogs: 0,
      logsDataLoad: 0,
      pagesOwnLogs: 0,
      ownLogsDataLoad: 0,
      loadAllPageData: 1,
      exportTable: 'user',
      message: '',
      isVisible: true,
      animation: true
    }
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    }
  },
  watch: {
    'progress': 'checkProgress',
    exportTable: function (newVal, oldVal) {
      switch (newVal) {
        case 'user':
          if (this.pagesUser > 0) {
            this.message = ''
            this.isVisible = false
          } else {
            this.message = 'データーはありません。'
            this.isVisible = true
          }
          break
        case 'pcode':
          if (this.pagesPcode > 0) {
            this.message = ''
            this.isVisible = false
          } else {
            this.message = 'データーがありません。'
            this.isVisible = true
          }
          break
        case 'phone':
          if (this.pagesPhone > 0) {
            this.message = ''
            this.isVisible = false
          } else {
            this.message = 'データーがありません。'
            this.isVisible = true
          }
          break
        case 'gate':
          if (this.pagesGate > 0) {
            this.message = ''
            this.isVisible = false
          } else {
            this.message = 'データーがありません。'
            this.isVisible = true
          }
          break
        case 'group':
          if (this.pagesGroup > 0) {
            this.message = ''
            this.isVisible = false
          } else {
            this.message = 'データーがありません。'
            this.isVisible = true
          }
          break
        case 'groupuser':
          if (this.pagesGroupUser > 0) {
            this.message = ''
            this.isVisible = false
          } else {
            this.message = 'データーがありません。'
            this.isVisible = true
          }
          break
        case 'groupgate':
          if (this.pagesGroupGate > 0) {
            this.message = ''
            this.isVisible = false
          } else {
            this.message = 'データーがありません。'
            this.isVisible = true
          }
          break
      }
    },
    loadAllPageData: function (newVal, oldVal) {
      if (newVal === 8) {
        this.isVisible = false
      }
    },
    userDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesUser) {
        this.isVisible = false
        this.downloadCSV()
        this.reset()
      } else if (newVal > 0) {
        this.getDataForUser(newVal + 1)
      }
    },
    pcodeDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesPcode) {
        this.isVisible = false
        this.downloadCSV()
        this.reset()
      } else if (newVal > 0) {
        this.getDataForPcode(newVal + 1)
      }
    },
    phoneDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesPhone) {
        this.isVisible = false
        this.downloadCSV()
        this.reset()
      } else if (newVal > 0) {
        this.getDataForPhone(newVal + 1)
      }
    },
    gateDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesGate) {
        this.isVisible = false
        this.downloadCSV()
        this.reset()
      } else if (newVal > 0) {
        this.getDataForGate(newVal + 1)
      }
    },
    groupDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesGroup) {
        this.isVisible = false
        this.downloadCSV()
        this.reset()
      } else if (newVal > 0) {
        this.getDataForGroup(newVal + 1)
      }
    },
    groupUserDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesGroupUser) {
        this.isVisible = false
        this.downloadCSV()
        this.reset()
      } else if (newVal > 0) {
        this.getDataForGroupUser(newVal + 1)
      }
    },
    groupGateDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesGroupGate) {
        this.isVisible = false
        this.downloadCSV()
        this.reset()
      } else if (newVal > 0) {
        this.getDataForGroupGate(newVal + 1)
      }
    },
    logsDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesLogs) {
        this.downloadCSV()
      }
    },
    ownLogsDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesOwnLogs) {
        this.downloadCSV()
      }
    }
  },
  created () {
    this.getPagesUser()
    this.getPagesPcode()
    this.getPagesPhone()
    this.getPagesGate()
    this.getPagesGroup()
    this.getPagesGroupUser()
    this.getPagesGroupGate()
    // this.getPagesLogs()
    // this.getPagesOwnLogs()
  },
  methods: {
    // 実行状態チェック
    checkProgress () {
      if (Math.round(this.progress) === 100) {
        this.success = true
        this.animation = false
      }
    },
    resetProcess () {
      setTimeout(() => {
        this.success = false
      }, 200)
      this.animation = false
    },
    converToDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD')
    },
    converToDateLog (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD HH:mm:ss')
    },
    exportDataExe () {
      var vm = this
      vm.isVisible = true
      this.progress = 0
      switch (vm.exportTable) {
        case 'user':
          vm.readTextFile('../../../static/headertxt/user.txt')
          if (vm.pagesUser > 0) {
            vm.getDataForUser(1)
          } else {
            vm.isVisible = false
            vm.message = 'データーはありません。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
          break
        case 'pcode':
          vm.readTextFile('../../../static/headertxt/pcode.txt')
          if (vm.pagesPcode > 0) {
            vm.getDataForPcode(1)
          } else {
            vm.message = 'データーはありません。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
          break
        case 'phone':
          vm.readTextFile('../../../static/headertxt/phone.txt')
          if (vm.pagesPhone > 0) {
            vm.getDataForPhone(1)
          } else {
            vm.message = 'データーはありません。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
          break
        case 'gate':
          vm.readTextFile('../../../static/headertxt/gate.txt')
          if (vm.pagesGate > 0) {
            vm.getDataForGate(1)
          } else {
            vm.message = 'データーはありません。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
          break
        case 'group':
          vm.readTextFile('../../../static/headertxt/group.txt')
          if (vm.pagesGroup > 0) {
            vm.getDataForGroup(1)
          } else {
            vm.message = 'データーはありません。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
          break
        case 'groupuser':
          vm.readTextFile('../../../static/headertxt/groupuser.txt')
          if (vm.pagesGroupUser > 0) {
            vm.getDataForGroupUser(1)
          } else {
            vm.message = 'データーはありません。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
          break
        case 'groupgate':
          vm.readTextFile('../../../static/headertxt/groupgate.txt')
          if (vm.pagesGroupGate > 0) {
            vm.getDataForGroupGate(1)
          } else {
            vm.message = 'データーはありません。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
          break
        default:
          vm.message = 'データーはありません。'
          $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
            $('#error-alert').slideUp(500)
          })
          break
      }
    },
    viewData () {
      console.log(this.exportData)
    },
    convertArrayOfObjectsToCSV (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data
      data = args.data || null
      if (data == null || !data.length) {
        return null
      }
      columnDelimiter = args.columnDelimiter || ','
      lineDelimiter = args.lineDelimiter || '\n'
      keys = Object.keys(data[0])
      result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter
      data.forEach(function (item) {
        ctr = 0
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })
      return result
    },
    downloadCSV () {
      var vm = this
      var filename
      var csv = this.convertArrayOfObjectsToCSV({
        data: vm.exportData
      })
      filename = vm.exportTable + '-data.csv' || 'export.csv'
      var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      var blob = new Blob([ bom, csv ], {type: 'text/csv;charset=utf-8;'})
      // ダウンロード実行
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      if (isSafari) {
        saveAs(blob, filename)
      } else {
        if (window.navigator.msSaveOrOpenBlob) {
          // IEの場合
          navigator.msSaveBlob(blob, filename)
        } else {
          // IE以外(Chrome, Firefox)
          var downloadLink = $('<a></a>')
          downloadLink.attr('href', window.URL.createObjectURL(blob))
          downloadLink.attr('download', filename)
          downloadLink.attr('target', '_blank')
          $('body').append(downloadLink)
          downloadLink[0].click()
          downloadLink.remove()
        }
      }
    },
    readTextFile (file) {
      var vm = this
      var rawFile = new XMLHttpRequest()
      rawFile.open('GET', file, false)
      rawFile.onreadystatechange = function () {
        if (rawFile.readyState === 4) {
          if (rawFile.status === 200 || rawFile.status === 0) {
            vm.headerData = rawFile.responseText.split('\n')
          } else {
            vm.message = 'HEADERのデーターはありません。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
        }
      }
      rawFile.send(null)
    },
    reset () {
      this.exportData = []
      this.headerData = []
      this.userDataLoad = 0
      this.pcodeDataLoad = 0
      this.phoneDataLoad = 0
      this.gateDataLoad = 0
      this.groupDataLoad = 0
      this.groupUserDataLoad = 0
      this.groupGateDataLoad = 0
      this.logsDataLoad = 0
      this.ownLogsDataLoad = 0
    },
    showAvatar (imgdata) {
      return 'data:image/png;base64,' + imgdata
    },
    converToBit (text) {
      var str = text.toString()
      if (str !== null && str !== '') {
        str = str.trim().toLowerCase()
      } else {
        str = 'false'
      }
      switch (str) {
        case 'true':
          return 1
        case 'false':
          return 0
        default:
          return 1
      }
    },
    getDataForUser (page) {
      var vm = this
      this.$http.get(Config.USERS_LIST_API + '?limit=1000&page=' + page + '&exclude=thumbnail')
        .then(response => {
          console.log(response)
          vm.userDataLoad++
          this.userData = response.body.users
          this.userData.forEach(function (item) {
            vm.exportData.push({
              [vm.headerData[0]]: item.userId,
              [vm.headerData[1]]: '',
              [vm.headerData[2]]: item.name,
              [vm.headerData[3]]: item.furigana,
              [vm.headerData[4]]: item.email,
              [vm.headerData[5]]: vm.converToBit(item.isMfaSms),
              [vm.headerData[6]]: String.fromCharCode(8203) + item.phoneNumber.replace('+81', '0'),
              [vm.headerData[7]]: vm.converToBit(item.isAdmin),
              [vm.headerData[8]]: vm.converToBit(item.isPhoneAdmin),
              [vm.headerData[9]]: vm.converToBit(item.shareKeyBeValid),
              [vm.headerData[10]]: item.passCode,
              [vm.headerData[11]]: '',
              [vm.headerData[12]]: item.option1,
              [vm.headerData[13]]: item.option2,
              [vm.headerData[14]]: vm.converToBit(item.isValid),
              [vm.headerData[15]]: vm.converToDate(item.registered),
              [vm.headerData[16]]: vm.converToDate(item.updated)
            })
          })
          vm.progress += vm.percentUser
        })
        .catch(error => {
          vm.progress += vm.percentUser
          console.log(error)
        })
    },
    getPagesUser () {
      var vm = this
      this.$http.get(Config.USERS_LIST_API + '?exclude=thumbnail')
        .then(response => {
          vm.loadAllPageData++
          if (response.body.maxRecords > 0) {
            vm.pagesUser = Math.ceil((response.body.maxRecords) / 1000)
            vm.percentUser = (100 / (vm.pagesUser))
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDataForPcode (page) {
      var vm = this
      this.$http.get(Config.PCODE_LIST_API + '?limit=1000&page=' + page)
        .then(response => {
          console.log(response)
          vm.pcodeDataLoad++
          this.pcodeData = response.body.pCodes
          this.pcodeData.forEach(function (item) {
            vm.exportData.push({
              [vm.headerData[0]]: item.userId,
              [vm.headerData[1]]: item.pCodeId,
              [vm.headerData[2]]: item.type,
              [vm.headerData[3]]: vm.converToBit(item.isValid),
              [vm.headerData[4]]: vm.converToDate(item.registered),
              [vm.headerData[5]]: vm.converToDate(item.updated)
            })
          })
          vm.progress += vm.percentPcode
        })
        .catch(error => {
          vm.progress += vm.percentPcode
          console.log(error)
        })
    },
    getPagesPcode () {
      var vm = this
      this.$http.get(Config.PCODE_LIST_API)
        .then(response => {
          vm.loadAllPageData++
          if (response.body.maxRecords > 0) {
            vm.pagesPcode = Math.ceil((response.body.maxRecords) / 1000)
            vm.percentPcode = (100 / (vm.pagesPcode))
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDataForPhone (page) {
      var vm = this
      this.$http.get(Config.PHONES_LIST_API + '?limit=1000&page=' + page)
        .then(response => {
          console.log(response)
          vm.phoneDataLoad++
          this.phoneData = response.body.phones
          this.phoneData.forEach(function (item) {
            vm.exportData.push({
              [vm.headerData[0]]: item.userId,
              [vm.headerData[1]]: item.phoneId,
              [vm.headerData[2]]: item.model,
              [vm.headerData[3]]: vm.converToBit(item.isValid),
              [vm.headerData[4]]: item.status,
              [vm.headerData[5]]: vm.converToDate(item.registered),
              [vm.headerData[6]]: vm.converToDate(item.updated)
            })
          })
          vm.progress += vm.percentPhone
        })
        .catch(error => {
          vm.progress += vm.percentPhone
          console.log(error)
        })
    },
    getPagesPhone () {
      var vm = this
      this.$http.get(Config.PHONES_LIST_API)
        .then(response => {
          vm.loadAllPageData++
          if (response.body.maxRecords > 0) {
            vm.pagesPhone = Math.ceil((response.body.maxRecords) / 1000)
            vm.percentPhone = (100 / (vm.pagesPhone))
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDataForGate (page) {
      var vm = this
      this.$http.get(Config.GATES_LIST_API + '?limit=1000&page=' + page)
        .then(response => {
          console.log(response)
          vm.gateDataLoad++
          this.gateData = response.body.gates
          this.gateData.forEach(function (item) {
            vm.exportData.push({
              [vm.headerData[0]]: item.gateId,
              [vm.headerData[1]]: item.gateName,
              [vm.headerData[2]]: item.gateModelId,
              [vm.headerData[3]]: item.gateModelName,
              [vm.headerData[4]]: item.gateModelCode,
              [vm.headerData[5]]: item.iconType,
              [vm.headerData[6]]: item.makerCode,
              [vm.headerData[7]]: vm.converToBit(item.customizable),
              [vm.headerData[8]]: item.target,
              [vm.headerData[9]]: item.controlTime,
              [vm.headerData[10]]: item.timeUnit,
              [vm.headerData[11]]: vm.converToBit(item.isVisitor),
              [vm.headerData[12]]: vm.converToBit(item.isNFCValid),
              [vm.headerData[13]]: vm.converToBit(item.isTenKeyValid),
              [vm.headerData[14]]: vm.converToBit(item.isGatePasswordValid),
              [vm.headerData[15]]: item.gatePasswordLength,
              [vm.headerData[16]]: item.gatePasswordSeed,
              [vm.headerData[17]]: vm.converToBit(item.isTwoStepAuthValid),
              [vm.headerData[18]]: item.bleIntensity,
              [vm.headerData[19]]: item.buzzerPattern,
              [vm.headerData[20]]: item.option1,
              [vm.headerData[21]]: item.option2,
              [vm.headerData[22]]: item.gateSNMain,
              [vm.headerData[23]]: item.gateSNBLE,
              [vm.headerData[24]]: item.gateFWMain,
              [vm.headerData[25]]: item.gateFWBLE,
              [vm.headerData[26]]: vm.converToDate(item.registered),
              [vm.headerData[27]]: vm.converToDate(item.updated),
              [vm.headerData[28]]: item.reported,
              [vm.headerData[29]]: item.revisionDesired,
              [vm.headerData[30]]: item.revisionReported,
              [vm.headerData[31]]: item.voltage,
              [vm.headerData[32]]: item.scanDate,
              [vm.headerData[33]]: vm.converToBit(item.isValid),
              [vm.headerData[34]]: item.status
            })
          })
          vm.progress += vm.percentGate
        })
        .catch(error => {
          vm.progress += vm.percentGate
          console.log(error)
        })
    },
    getPagesGate () {
      var vm = this
      this.$http.get(Config.GATES_LIST_API)
        .then(response => {
          vm.loadAllPageData++
          if (response.body.maxRecords > 0) {
            vm.pagesGate = Math.ceil((response.body.maxRecords) / 1000)
            vm.percentGate = (100 / (vm.pagesGate))
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDataForGroup (page) {
      var vm = this
      this.$http.get(Config.GROUPS_LIST_API + '?limit=1000&page=' + page)
        .then(response => {
          console.log(response)
          vm.groupDataLoad++
          this.groupData = response.body.groups
          this.groupData.forEach(function (item) {
            vm.exportData.push({
              [vm.headerData[0]]: item.groupId,
              [vm.headerData[1]]: item.name,
              [vm.headerData[2]]: vm.converToDate(item.registered),
              [vm.headerData[3]]: vm.converToDate(item.updated),
              [vm.headerData[4]]: vm.converToBit(item.isValid)
            })
          })
          vm.progress += vm.percentGroup
        })
        .catch(error => {
          vm.progress += vm.percentGroup
          console.log(error)
        })
    },
    getPagesGroup () {
      var vm = this
      this.$http.get(Config.GROUPS_LIST_API)
        .then(response => {
          vm.loadAllPageData++
          if (response.body.maxRecords > 0) {
            vm.pagesGroup = Math.ceil((response.body.maxRecords) / 1000)
            vm.percentGroup = (100 / (vm.pagesGroup))
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDataForGroupUser (page) {
      var vm = this
      this.$http.get(Config.GROUPS_PASSAGE_API + '?limit=1000&page=' + page)
        .then(response => {
          console.log(response)
          vm.groupUserDataLoad++
          this.groupUserData = response.body.groupPassages
          this.groupUserData.forEach(function (item) {
            vm.exportData.push({
              [vm.headerData[0]]: item.groupPassageId,
              [vm.headerData[1]]: item.groupId,
              [vm.headerData[2]]: item.userId
            })
          })
          vm.progress += vm.percentGroupUser
        })
        .catch(error => {
          vm.progress += vm.percentGroupUser
          console.log(error)
        })
    },
    getPagesGroupUser () {
      var vm = this
      this.$http.get(Config.GROUPS_PASSAGE_API)
        .then(response => {
          vm.loadAllPageData++
          if (response.body.maxRecords > 0) {
            vm.pagesGroupUser = Math.ceil((response.body.maxRecords) / 1000)
            vm.percentGroupUser = (100 / (vm.pagesGroupUser))
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDataForGroupGate (page) {
      var vm = this
      this.$http.get(Config.RELATION_GATE_GROUP_API + '?limit=1000&page=' + page)
        .then(response => {
          console.log(response)
          vm.groupGateDataLoad++
          this.groupGateData = response.body.relationsGateGroup
          this.groupGateData.forEach(function (item) {
            vm.exportData.push({
              [vm.headerData[0]]: item.relationId,
              [vm.headerData[1]]: item.groupId,
              [vm.headerData[2]]: item.gateId
            })
          })
          vm.progress += vm.percentGroupGate
        })
        .catch(error => {
          vm.progress += vm.percentGroupGate
          console.log(error)
        })
    },
    getPagesGroupGate () {
      var vm = this
      this.$http.get(Config.RELATION_GATE_GROUP_API)
        .then(response => {
          vm.loadAllPageData++
          if (response.body.maxRecords > 0) {
            vm.pagesGroupGate = Math.ceil((response.body.maxRecords) / 1000)
            vm.percentGroupGate = (100 / (vm.pagesGroupGate))
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDataForLogs (page) {
      var vm = this
      this.$http.get(Config.LOG_GATE_LIST_API + '?limit=1000&page=' + page)
        .then(response => {
          console.log(response)
          vm.logsDataLoad++
          this.logsData = response.body.logs
          this.logsData.forEach(function (item) {
            vm.exportData.push({
              [vm.headerData[0]]: vm.converToDateLog(item.timestamp),
              [vm.headerData[1]]: item.userId,
              [vm.headerData[2]]: item.userName,
              [vm.headerData[3]]: item.userFurigana,
              [vm.headerData[4]]: item.gateId,
              [vm.headerData[5]]: item.gateName,
              [vm.headerData[6]]: item.deviceId,
              [vm.headerData[7]]: item.deviceType,
              [vm.headerData[8]]: item.accessLogId,
              [vm.headerData[9]]: item.logLabel,
              [vm.headerData[10]]: item.sequenceNo,
              [vm.headerData[11]]: item.voltage
            })
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPagesLogs () {
      var vm = this
      this.$http.get(Config.LOG_GATE_LIST_API)
        .then(response => {
          vm.loadAllPageData++
          if (response.body.maxRecords > 0) {
            vm.pagesLogs = Math.ceil((response.body.maxRecords) / 1000)
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDataForOwnLogs (page) {
      var vm = this
      this.$http.get(Config.LOG_OWNER_LIST_API + '?limit=1000&page=' + page)
        .then(response => {
          console.log(response)
          vm.ownLogsDataLoad++
          this.ownLogsData = response.body.logs
          this.ownLogsData.forEach(function (item) {
            vm.exportData.push({
              [vm.headerData[0]]: vm.converToDateLog(item.timestamp),
              [vm.headerData[1]]: item.userId,
              [vm.headerData[2]]: item.name,
              [vm.headerData[3]]: item.furigana,
              [vm.headerData[4]]: item.action,
              [vm.headerData[5]]: item.targetTable,
              [vm.headerData[6]]: item.targetRecord,
              [vm.headerData[7]]: item.changeSet,
              [vm.headerData[8]]: item.result
            })
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPagesOwnLogs () {
      var vm = this
      this.$http.get(Config.LOG_OWNER_LIST_API)
        .then(response => {
          vm.loadAllPageData++
          if (response.body.maxRecords > 0) {
            vm.pagesOwnLogs = Math.ceil((response.body.maxRecords) / 1000)
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
<style>
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    border-radius: 10px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41!important
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
  .field{
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    background: #ABBAC3;
  }
</style>



// WEBPACK FOOTER //
// src/views/export/ExportIndex.vue